import PlainHeaderAndPictureSection from "./Components/PlainHeaderAndPictureSection";
import OurDifferences from "./Components/OurDifferences";
import OurStory from "./Components/OurStory";
import { useTranslation } from "react-i18next";

const AboutUs = () => {
  const { t } = useTranslation();

  const differencesArray = [
    {
      header: t("landing.aboutUs.differences.customizable.header"),
      text: t("landing.aboutUs.differences.customizable.text"),
    },
    {
      header: t("landing.aboutUs.differences.scientific.header"),
      text: t("landing.aboutUs.differences.scientific.text"),
    },
    {
      header: t("landing.aboutUs.differences.richContent.header"),
      text: t("landing.aboutUs.differences.richContent.text"),
    },
    {
      header: t("landing.aboutUs.differences.dataInsight.header"),
      text: t("landing.aboutUs.differences.dataInsight.text"),
    },
    {
      header: t("landing.aboutUs.differences.userFriendly.header"),
      text: t("landing.aboutUs.differences.userFriendly.text"),
    },
  ];

  return (
    <div>
      <div>
        <PlainHeaderAndPictureSection
          imageSrc={"/LandingPageImages/triplePictureWithGradientBackground.webp"}
          headerText={t("landing.nav.aboutUs")}
          isImageOnRight={true}
        >
          {t("landing.aboutUs.intro")}
        </PlainHeaderAndPictureSection>

        <OurDifferences headerText={t("landing.aboutUs.ourDifference")} differencesArray={differencesArray}>
          {t("landing.aboutUs.differenceDescription")}
        </OurDifferences>

        <OurStory headerText={t("landing.aboutUs.ourStory")}>{t("landing.aboutUs.storyDescription")}</OurStory>
      </div>
    </div>
  );
};
export default AboutUs;
